module.exports = __webpack_public_path__ + "img/m_footer.2ab81e3a.png";